
import { computed, defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import CardV2 from '@/views/dashboard/_components/card-v2/card-v2.vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import Copy from '@/views/_components/copy/copy.vue'
import {
  ServiceCommonService
} from '@/views/dashboard/service/service-common.service'
import Countdown from '@/views/_components/countdown/countdown.vue'
import { RenewalServiceService, ServiceList } from '@/views/dashboard/service/subscribe-details/_components/renewal-service.service'
import { formatTimeStamp } from '@/utils/time'
import ServiceEnum from '@/views/dashboard/service/_components/service-enum/service-enum.vue'
import { DateKindLabel } from '@/views/dashboard/service/_enum/date-kind'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import { isAiAssistantSubscribeItem } from '@/views/dashboard/service/service-subscribe/ai-assistant-detail/ai-assistant.service'
import { openQidianOnlineService } from '@/config/external-link'

export default defineComponent({
  components: { ServiceEnum, Countdown, Copy, CardV2 },
  emits: ['changeSelect', 'navigateServiceSubscribe'],
  props: {
    isPrivate: {
      type: Boolean,
      default: false
    }
  },

  setup (props, context) {
    const { t, te, locale } = useI18n()
    const injector = useReflectiveInjector([ServiceCommonService, RenewalServiceService])
    const serviceCommonService = injector.get(ServiceCommonService)
    const service = injector.get(RenewalServiceService)

    const tableNode = ref()
    const isLoading = ref(false)
    const tableData = ref<ServiceList[]>([])
    const selectionData = ref<ServiceList[]>([])
    const selectionShot = ref<ServiceList[]>([])
    const isShowSelection = ref(false)

    const isPrivateLike = computed(() => props.isPrivate || IS_JP_ONLY_BUILD)

    const selectedCount = computed(() => {
      return selectionData.value.length
    })

    function updateData () {
      isLoading.value = true
      return service.getServiceList({}).then((res) => {
        tableData.value = res.service_list
        isLoading.value = false
      }).catch((error) => {
        isLoading.value = false
      })
    }

    function handleCancelSelect () {
      tableNode.value.clearSelection()
      toggleShowSelected(false)
    }

    function handleSelectionChange (values: ServiceList[]) {
      selectionData.value = values
      context.emit('changeSelect', selectionData.value.map(v => v.price_id), selectionData.value)
    }

    /** AI 助手不支持批量续订：作为 selection 列的 selectable 判据（置灰不可勾选） */
    function isRenewalRowSelectable (row: ServiceList) {
      return !isAiAssistantSubscribeItem(row)
    }

    /**
     * 切换展示已选数据
     * @param show 如果使用了show参数，则是切换到指定状态。不设置表示切换反状态
     */
    function toggleShowSelected (show?: boolean) {
      isShowSelection.value = typeof show === 'boolean' ? show : !isShowSelection.value
      if (isShowSelection.value) {
        selectionShot.value = [...selectionData.value]
        updateSelectionShow()
      } else {
        updateData()
      }
    }

    function updateSelectionShow () {
      tableData.value = selectionShot.value
    }

    function onServiceSubscribeLinkClick () {
      context.emit('navigateServiceSubscribe')
    }

    function serviceDisplayName (item: ServiceList) {
      void locale.value
      const id = item.price_id
      if (id == null) return item.display_name || ''
      const key = `mySubscribe.priceTitle.${id}`
      return te(key) ? String(t(key)) : (item.display_name || '')
    }

    updateData().then(() => {
      tableNode.value.toggleAllSelection()
    })

    return {
      DateKindLabel,
      isPrivateLike,
      tableNode,
      tableData,
      selectedCount,
      isShowSelection,
      t,
      handleCancelSelect,
      formatTimeStamp,
      toggleShowSelected,
      onServiceSubscribeLinkClick,
      serviceDisplayName,
      isRenewalRowSelectable,
      isAiAssistantSubscribeItem,
      handleSelectionChange,
      openQidianOnlineService,
    }
  }
})
